// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getVm(order_fare, currency) {
  var payment = order_fare.payment_break_up_details;
  if (payment !== undefined) {
    return {
            fare_payable: Currency.toCurrencyString(Belt_Option.mapWithDefault(payment.summary.fare_payable, order_fare.fare_details.estimated.amount, (function (c) {
                        return c.amount;
                      })), currency),
            driver_collected_cash: Currency.toCurrencyString(payment.breakup.actual_driver_collected_cash.amount, currency),
            cashback: Currency.toCurrencyString(payment.breakup.cashback.amount, currency),
            porter_credits: Currency.toCurrencyString(payment.breakup.porter_credits.amount, currency),
            instamojo_amount: Currency.toCurrencyString(payment.breakup.instamojo.amount, currency),
            razorpay_amount: Currency.toCurrencyString(payment.breakup.razorpay.amount, currency),
            paytm_amount: Currency.toCurrencyString(payment.breakup.paytm.amount, currency),
            business_account: Currency.toCurrencyString(payment.breakup.business_account.amount, currency),
            muneemji: Currency.toCurrencyString(payment.breakup.muneemji.amount, currency)
          };
  } else {
    return {
            fare_payable: "N/A",
            driver_collected_cash: "N/A",
            cashback: "N/A",
            porter_credits: "N/A",
            instamojo_amount: "N/A",
            razorpay_amount: "N/A",
            paytm_amount: "N/A",
            business_account: "N/A",
            muneemji: "N/A"
          };
  }
}

export {
  getVm ,
  
}
/* No side effect */
